import { useSelector } from "react-redux";
import { RootSliceType } from "redux/reducers/rootReducer";
import {IReservationIndividualCompleted} from "../reducers/reservationIndividualCompletedSlice";

const useReservationIndividualCompleted = () => {
    const reservationIndividualCompleted = useSelector<
        RootSliceType,
        IReservationIndividualCompleted["reservationIndividualCompleted"]
        >((state) => state.reservationIndividualCompletedSlice.reservationIndividualCompleted);

    const loading = useSelector<
        RootSliceType,
        IReservationIndividualCompleted["loading"]
        >((state) => state.reservationIndividualCompletedSlice.loading);

    return {
        reservationIndividualCompleted,
        loading,
    };
};

export default useReservationIndividualCompleted;
